import React from 'react';

import { ModalContext } from './context';

export const ModalProvider: React.FC = props => {
  const [isOpen, setIsOpen] = React.useState(false);

  const value = React.useMemo(() => ({
    isOpen,
    setIsOpen,
  }), [isOpen]);

  return (
    <ModalContext.Provider value={value}>
      {props.children}
    </ModalContext.Provider>
  );
};